module.exports = __webpack_public_path__ + "assets/img/order-head-back2.18f319d2.png";